// extracted by mini-css-extract-plugin
export default {"fs":"cec67a9be8 f9466ae82c"};